// extracted by mini-css-extract-plugin
export var arbiterSwatch = "_2t-3";
export var dialog = "_2t-0";
export var divClassnameSwatch = "_2t-8";
export var flexSwatch = "_2t-4";
export var header = "_2t-1";
export var styleAttributeSwatch = "_2t-7";
export var swatch = "_2t-2";
export var textHeaderSwatch = "_2t-5";
export var webSwatch = "_2t-6";